import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	relatedWorkHeading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	addRelatedWork: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showMore: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	showLess: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	relatedWorkHeading: {
		id: 'software-releases-version-related-work.related-work-heading',
		defaultMessage: 'Related work',
		description:
			'Subheading for a section of the page which shows links that are related to the version',
	},
	addRelatedWork: {
		id: 'software-releases-version-related-work.add-related-work',
		defaultMessage: 'Add links, release notes, and more…',
		description:
			'Text for a button that allows the user to add an association (link) to their version.',
	},
	showMore: {
		id: 'software-releases-version-related-work.show-more',
		defaultMessage: 'Show {moreItemsCount} more',
		description: 'Title of a button that shows the rest of the related-work list.',
	},
	showLess: {
		id: 'software-releases-version-related-work.show-less',
		defaultMessage: 'Show {moreItemsCount} less',
		description: 'Title of a button that hides the rest of the related-work list.',
	},
});
export default messages;
